module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/Desktop/sailing-work/mapbox/mapboxProject/node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/promise.js
// module id = rVsN
// module chunks = 1